import { Component,  Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { ModalResponse } from '../../../models/modal-response';

export interface NavigateToDocQuestionModalData {
  id: string;
  gifLoader: boolean;
}


@Component( {
  selector: 'navigate-to-doc-question-modal',
  templateUrl: './navigate-to-doc-question-modal.component.html',
  styleUrls: [ './navigate-to-doc-question-modal.component.scss' ],
  imports: [
    TranslateModule,
    MatDialogModule,
    NgIf
  ],
  standalone: true
})
export class NavigateToDocQuestionModalComponent implements OnInit {

  ModalResponse = ModalResponse;
  loading: boolean;
  constructor(
    public dialogRef: MatDialogRef<NavigateToDocQuestionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NavigateToDocQuestionModalData
  ) {
  }

  ngOnInit() {
    console.log(this.data);
  }

  closeDialog(response: ModalResponse) {
    this.dialogRef.close(response);
  }

}
